// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3DOyU","spinnerBorder":"_23Y1h","primary":"qcjBQ","loading":"_3j58K","loaderWrapper":"vVpfj","wait":"_3WGqL","detail":"_2derx","toast":"hYnMg"};